export const TargetedCatalogActionKeys = {
  ADD_TARGETED_CATALOG_ITEMS: 'ADD_TARGETED_CATALOG_ITEMS',
  DELETE_TARGETED_CATALOG_ITEM: 'DELETE_TARGETED_CATALOG_ITEM',
  DELETE_TARGETED_CATALOG_SECTION: 'DELETE_TARGETED_CATALOG_SECTION',
  DELETE_TARGETED_ITEM_GROUP: 'DELETE_TARGETED_ITEM_GROUP',
  FETCH_TARGETED_CATALOG: 'FETCH_TARGETED_CATALOG',
  REMOVE_TARGETED_CATALOG_ITEM: 'REMOVE_TARGETED_CATALOG_ITEM',
  REMOVE_TARGETED_CATALOG_SECTION: 'REMOVE_TARGETED_CATALOG_SECTION',
  REMOVE_TARGETED_ITEM_GROUP: 'REMOVE_TARGETED_ITEM_GROUP',
  SET_TARGETED_CATALOG: 'SET_TARGETED_CATALOG',
  SET_TARGETED_CATALOG_ITEM_SEARCH_RESULT: 'SET_TARGETED_CATALOG_ITEM_SEARCH_RESULT',
  SET_TARGETED_CATALOG_SECTION_MIN: 'SET_TARGETED_CATALOG_SECTION_MIN',
  SET_TARGETED_CATALOG_SELECTED_SECTION: 'SET_TARGETED_CATALOG_SELECTED_SECTION',
  SET_TARGETED_ITEM_GROUPS: 'SET_TARGETED_ITEM_GROUPS',
  TARGETED_CATALOG_ITEM_SEARCH: 'TARGETED_CATALOG_ITEM_SEARCH',
  TOGGLE_TARGETED_CATALOG_ITEM_SEARCH: 'TOGGLE_TARGETED_CATALOG_ITEM_SEARCH',
  UPDATE_TARGETED_CATALOG_ITEM_ORDER: 'UPDATE_TARGETED_CATALOG_ITEM_ORDER',
  UPDATE_TARGETED_CATALOG_SECTION: 'UPDATE_TARGETED_CATALOG_SECTION',
  UPDATE_TARGETED_ITEM_GROUP: 'UPDATE_TARGETED_ITEM_GROUP',
  UPDATE_TARGETED_ITEM_GROUP_ORDER: 'UPDATE_TARGETED_ITEM_GROUP_ORDER'
} as const;
